import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Pager, PurchaseOrderContractTask } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0780. 発注案件契約タスク一覧
 * [GET] /workspaces/:identifier/purchase_order_contract_tasks
 */
type Props = {
  identifier: string;
  page?: number;
  per?: number;
  purchase_order_contract_task_phase_ids?: number[];
  user_ids?: number[];
  business_partner_ids?: number[];
  team_ids?: number[];
  subscribed?: boolean;
  purchase_order_id?: number;
  archived?: boolean;
  enabled?: boolean;
};

export type PurchaseOrderContractTasksResponse = {
  purchase_order_contract_tasks: PurchaseOrderContractTask[];
  pager: Pager;
};
const purchaseOrderContractTasks = (props: Props): Promise<PurchaseOrderContractTasksResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/purchase_order_contract_tasks`, { params: props });
};

export const usePurchaseOrderContractTasks = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'purchase_order_contract_tasks', { ...props }],
    queryFn: () => purchaseOrderContractTasks(props),
    enabled: props.enabled,
  });
};

export const usePurchaseOrderContractTasksInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'purchase_order_contract_tasks'] });
  };

  return { invalidate };
};
